import { Component } from '@angular/core';

@Component({
  selector: 'app-injection-moulding-machine',
  templateUrl: './injection-moulding-machine.component.html',
  styleUrls: ['./injection-moulding-machine.component.scss']
})
export class InjectionMouldingMachineComponent {
  conveyersystem:any[] = [
    {
      title: 'Toggle-clamping Hydraulic Injection Molding Machine',
      img: 'assets/images/capability/white/injection_moulding_1.JPG',
    },
    {
      title: 'Vertical Injection Molding Machine',
      img: 'assets/images/capability/white/injection_moulding_2.JPG',
    },
    {
      title: 'Multi-component Injection Molding Machine​',
      img: 'assets/images/capability/white/injection_moulding_3.JPG',
    },
    {
      title: 'Two-platen Injection Molding Machine',
      img: 'assets/images/capability/white/injection_moulding_4.JPG',
    },
    {
      title: 'Electric Injection Molding Machine',
      img: 'assets/images/capability/white/injection_moulding_5.JPG',
    },
    {
      title: 'High-speed Injection Molding Machine​',
      img: 'assets/images/capability/white/injection_moulding_6.JPG',
    }
  ]

  materialmove:any[] = [
    {
      title: 'Milling​​​',
      img: 'assets/images/capability/white/rubber_extrusion.jpg',
    },
    {
      title: 'Broaching​​',
      img: 'assets/images/capability/white/cryogenic_deflashing.jpg',
    },
    {
      title: 'Honing, Super Finishing​',
      img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
    },
    {
      title: 'Turning​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Sliding Head',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Centreless Grinding​',
      img: 'assets/images/placeholder.jpg',
    }
  ]

  materialstorage:any[] = [
    {
      title: 'Milling​​​',
      img: 'assets/images/capability/white/rubber_extrusion.jpg',
    },
    {
      title: 'Broaching​​',
      img: 'assets/images/capability/white/cryogenic_deflashing.jpg',
    },
    {
      title: 'Honing, Super Finishing​',
      img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
    },
    {
      title: 'Turning​',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Sliding Head',
      img: 'assets/images/placeholder.jpg',
    },
    {
      title: 'Centreless Grinding​',
      img: 'assets/images/placeholder.jpg',
    }
  ]
}
